export const GET_FLAGS = "GET_FLAGS";
export const SET_FLAGS_REQUEST_STATUS = "SET_FLAGS_REQUEST_STATUS";
